import { createEffect, onCleanup, type Accessor } from 'solid-js';
import { setPageShareMirror, clearPageShareMirror } from '../store/pageShareStateStore';

/**
 * Mirror local page state into the share store while the page is mounted.
 */
export function useDashboardPageShareMirror(
  pageKey: string,
  getState: Accessor<Record<string, unknown>>
): void {
  createEffect(() => {
    setPageShareMirror(pageKey, getState());
  });

  onCleanup(() => {
    clearPageShareMirror(pageKey);
  });
}
